import React, { Fragment, useState } from "react";
import useFetchVesselImages from "../Utils/useFetchVesselImages";
import useImageDeletion from "../Utils/useImageDeletion";
import Skeleton from "react-loading-skeleton";
import { ToastContainer, toast } from "react-toastify";
import { CiWarning } from "react-icons/ci";
import "react-toastify/dist/ReactToastify.css";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const VesselImages = ({ vesselId }) => {
  const { data, isLoading, isError, error, refetch } = useFetchVesselImages(vesselId);
  const { deleting, selectedImages, setSelectedImages, deleteImages } = useImageDeletion(vesselId);
  const [deleteImgOverlay, setImgDeleteOverlay] = useState(false);
  const [collapsedSections, setCollapsedSections] = useState({
    vesselinimagess: true,
  });

  const toggleSection = (section) => {
    setCollapsedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  if (isError) {
    return <div>Error: {error.message}</div>;
  }

  const images = data?.data?.images || [];

  const handleImageSelect = (imageUrl) => {
    if (selectedImages.includes(imageUrl)) {
      setSelectedImages(selectedImages.filter((img) => img !== imageUrl));
    } else {
      setSelectedImages([...selectedImages, imageUrl]);
    }
  };

  const handleDeleteImages = async () => {
    if (selectedImages.length === 0) {
      toast.error("Select at least one image to delete.");
      return;
    }

    await deleteImages(vesselId, selectedImages);
    setImgDeleteOverlay(false)
    refetch();
  };

  return (
    <Fragment>
      {deleteImgOverlay && (
        <div className="delete-details-overlay">
          <div className="card">
            <CiWarning className="warning" />
            <h2>Delete</h2>
            <p>Are you sure you want to delete the selected image(s)?</p>
            <div className="btn">
              <button
                onClick={() => {
                  setSelectedImages([]);
                  setImgDeleteOverlay(false);
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteImages}
                disabled={deleting || selectedImages.length === 0}
              >
                {deleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="myvessel-details-container">
        <div className="info" onClick={() => toggleSection("vesselinimagess")}>
          <p>Vessel Images</p>
          {collapsedSections.vesselinimagess ? (
            <IoIosArrowDown />
          ) : (
            <IoIosArrowUp />
          )}
        </div>
        {!collapsedSections.vesselinimagess && (
          <div className="images-grid">
            {isLoading ? (
              <>
                <Skeleton
                  count={1}
                  height={30}
                  width={300}
                  style={{ marginBottom: "20px" }}
                />
                <Skeleton count={3} height={200} />
              </>
            ) : images.length === 0 ? (
              <p className="images-error">No images available.</p>
            ) : (
              images.map((imageUrl, index) => (
                <div key={index} className="image-container">
                  <input
                    type="checkbox"
                    checked={selectedImages.includes(imageUrl)}
                    onChange={() => handleImageSelect(imageUrl)}
                    disabled={deleting}
                  />
                  <img src={imageUrl} alt={`Vessel ${index + 1}`} />
                </div>
              ))
            )}
          </div>
        )}
        {!collapsedSections.vesselinimagess && images.length > 0 && (
          <button
            onClick={() => setImgDeleteOverlay(true)}
            disabled={selectedImages.length === 0}
            className="btn"
          >
            Delete Selected Images
          </button>
        )}
        <ToastContainer />
      </div>
    </Fragment>
  );
};

export default VesselImages;
